import {Button, Container, Grid, Modal, Paper, Typography} from "@material-ui/core";
import React from "react";
import useStyles from "../../styles/styles";
import useTrafficStyles from "../../styles/trafficStyles";
import {Alert} from "@material-ui/lab";

const SetPromoIdConfirmationModal = ({input, promoId, highestTrafficSourcePromoId, setPromoIdMutation, closeModal}) => {
    const classes = useStyles();
    const trafficClasses = useTrafficStyles();

    const onConfirm = () => {
        setPromoIdMutation({
            variables: {
                promoId: input
            }
        })
    }

    const isCaution = input < highestTrafficSourcePromoId

    return <Modal
        open={true}
        onClose={closeModal}
    >
        <Container className={`${classes.modal} ${trafficClasses.smallModal} `} maxWidth={false}>
            <Paper className={classes.paper} style={{marginBottom: 0}}>
                <Typography variant="h5" align="center" gutterBottom>
                    Are you sure you want to set the promoId internal counter to {input}?
                </Typography>
                {isCaution ?
                    <Alert style={{alignItems: "center"}} severity={"error"}> <p>Current highest traffic source promoId is <strong>{highestTrafficSourcePromoId}</strong> -
                        Please make sure that you intend to set the counter to be less than the highest traffic source
                        promo Id</p></Alert>
                    : null
                }

                <Grid item xs className={trafficClasses.headerButtons}>
                    <Button variant="contained" color="primary" onClick={(e) => {
                        e.preventDefault();
                        onConfirm()
                    }}>
                        Confirm
                    </Button>
                    <Button variant="outlined" onClick={() => closeModal()}>
                        Cancel
                    </Button>
                </Grid>
            </Paper>
        </Container>
    </Modal>
}

export default SetPromoIdConfirmationModal